import { ContentType } from '../constants/contentTypes';

export enum ContentDifficulty {
  VERY_EASY = 'very_easy',
  EASY = 'easy',
  MODERATE = 'moderate',
  DIFFICULT = 'difficult',
  VERY_DIFFICULT = 'very_difficult'
}

export interface CompanyTag {
  id: number;
  name: string;
  description?: string;
  color?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface BaseContent {
  id: number;
  microtopic_id: number;
  type: string;
  difficulty: ContentDifficulty;
  created_at: string;
  updated_at: string;
  company_tags?: CompanyTag[];
}

export interface ContentPayload<T = unknown> {
  id: number;
  microtopic_id: number;
  type: ContentType;
  payload: T;
  created_at: string;
  updated_at: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  per_page: number;
}